import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as SettingsIcon } from './settings.svg';

export const Settings = IconHOC(SettingsIcon);
